import { z } from 'zod';
// ============================================================
// Payment Schemas
// ============================================================
export const PaymentTypeSchema = z.enum([
    'PREMIUM_UPGRADE',
    'AI_CREDITS',
    'AI_CREDITS_BUNDLE',
]);
export const PaymentStatusSchema = z.enum([
    'PENDING',
    'COMPLETED',
    'FAILED',
    'REFUNDED',
]);
export const PaymentMethodSchema = z.enum(['TOSS', 'KAKAO_PAY', 'CARD', 'NAVER_PAY']);
export const PaymentChannelSchema = z.enum(['SITE', 'SMARTSTORE']);
export const PaymentSchema = z.object({
    id: z.string().cuid2(),
    userId: z.string().cuid2(),
    type: PaymentTypeSchema,
    method: PaymentMethodSchema,
    amount: z.number().int().min(0),
    creditsGranted: z.number().int().min(0).nullable(),
    status: PaymentStatusSchema.default('PENDING'),
    orderId: z.string().max(255).nullable(),
    paymentKey: z.string().max(255).nullable(),
    createdAt: z.date(),
});
export const CreatePaymentRequestSchema = z.object({
    type: PaymentTypeSchema,
    method: PaymentMethodSchema.default('TOSS'),
});
export const ApprovePaymentRequestSchema = z.object({
    orderId: z.string().min(1, '주문 ID가 필요합니다'),
    paymentKey: z.string().min(1, '결제 키가 필요합니다'),
    amount: z.number().int().min(0, '결제 금액이 필요합니다'),
});
export const PaymentResponseSchema = PaymentSchema.omit({
    userId: true,
    paymentKey: true,
});
export const PaymentListResponseSchema = z.object({
    payments: z.array(PaymentResponseSchema),
    total: z.number().int().min(0),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1).max(100),
});
// ============================================================
// Smartstore
// ============================================================
export const ActivateSmartStoreRequestSchema = z.object({
    productOrderId: z
        .string()
        .min(1, '상품주문번호를 입력하세요')
        .regex(/^\d+$/, '상품주문번호는 숫자만 가능합니다'),
});
// ============================================================
// Constants
// ============================================================
export const PAYMENT_AMOUNTS = {
    PREMIUM_UPGRADE: 9900,
    AI_CREDITS: 1000,
    AI_CREDITS_BUNDLE: 8000,
};
export const CREDITS_GRANTED = {
    PREMIUM_UPGRADE: 10,
    AI_CREDITS: 1,
    AI_CREDITS_BUNDLE: 10,
};
export const validatePaymentAmount = (type, amount) => {
    return PAYMENT_AMOUNTS[type] === amount;
};
export const calculateCredits = (type) => {
    return CREDITS_GRANTED[type];
};
export const generateOrderId = (userId, type) => {
    const timestamp = Date.now();
    const random = Math.random().toString(36).substring(2, 8);
    return `${type}_${userId.slice(0, 8)}_${timestamp}_${random}`;
};
//# sourceMappingURL=payment.js.map